// extracted by mini-css-extract-plugin
export var ctaIcon = "HeroCta-module--ctaIcon--chAVb";
export var textOnlyCta = "HeroCta-module--text-only-cta--2Wyrb";